import { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react"
import { AppApi } from "services/api-routes"
import ApiV2 from "utility/ApiV2"
import DEBUG from "utility/IsDebugOn"
import { useToken } from "utility/context/Token"

export const TEXTOS_KEYS = {
  textoSucessoExecucaoProcedimentos: "executar-procedimentos.sucesso"
}

export const LOCALE_PADRAO = "pt-BR"

export const DEFAULT_TEXTS = {
  [LOCALE_PADRAO]: {
    [TEXTOS_KEYS.textoSucessoExecucaoProcedimentos]: "Procedimentos executados com sucesso!"
  }
}

const TextosPersonalizadosContext = createContext(null)

export const TextosPersonalizadosProvider = ({ children }) => {
  const { isAccessTokenValid } = useToken()
  const [textos, setTextos] = useState(DEFAULT_TEXTS)

  const api = useMemo(() => new ApiV2(), [])

  const carregarTextos = useCallback(
    (locale = LOCALE_PADRAO) => {
      if (!isAccessTokenValid) return
      api.get(
        AppApi.cadastros.empresa.textos,
        [locale],
        () => {},
        "Erro!",
        "Erro ao obter textos personalizados, favor tentar novamente ou contactar o suporte!",
        null,
        (resp) => {
          DEBUG() && console.log("Textos personalizados carregados (context):", resp)
          const data = resp?.data || {}
          setTextos((prev) => ({
            ...prev,
            ...data
          }))
        }
      )
    },
    [api, isAccessTokenValid]
  )

  useEffect(() => {
    if (isAccessTokenValid) {
      carregarTextos(LOCALE_PADRAO)
    }
  }, [isAccessTokenValid, carregarTextos])

  const getTexto = useCallback(
    (key, locale = LOCALE_PADRAO) => {
      const grupo = textos[locale] || {}
      const texto = grupo[key]

      if (texto && texto.trim().length > 0) return texto

      const grupoDefault = DEFAULT_TEXTS[locale] || {}
      return grupoDefault[key] || ""
    },
    [textos]
  )

  const value = useMemo(
    () => ({
      textos,
      getTexto,
      reloadTextos: () => carregarTextos(LOCALE_PADRAO)
    }),
    [textos, getTexto, carregarTextos]
  )

  return (
    <TextosPersonalizadosContext.Provider value={value}>
      {children}
    </TextosPersonalizadosContext.Provider>
  )
}

export const useTextosPersonalizados = () => {
  const ctx = useContext(TextosPersonalizadosContext)
  if (!ctx) {
    throw new Error("useTextosPersonalizados deve ser usado dentro de TextosPersonalizadosProvider")
  }
  return ctx
}
